import { PatientPayersActions } from 'src/redux/actions/constant';

const {
  GET_PAYER_HISTORY_SUCCESS,
  GET_PAYER_HISTORY_FAILURE,
  GET_PAYER_HISTORY_LOADING,
  GET_PAYER_HISTORY_RESET,
} = PatientPayersActions;

const initialState: any = {
  response: null,
  loading: false,
};

export const getPayerHistoryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PAYER_HISTORY_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case GET_PAYER_HISTORY_FAILURE:
      return {
        ...state,
        response: null,
        loading: false,
      };

    case GET_PAYER_HISTORY_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_PAYER_HISTORY_RESET:
      return initialState;

    default:
      return state;
  }
};
